export default __webpack_public_path__ + "static/media/dodawanie-paczki-1.3ddf6235.png";